import { useEffect, useRef } from 'react';
import { usePersistedLocation } from './usePersistedLocation';
import { supabase } from '@/integrations/supabase/client';

const PROMPTED_KEY = 'lat_geo_prompted';

export function useGeolocationPrompt() {
  const { savedLocation, saveLocation } = usePersistedLocation();
  const ran = useRef(false);

  useEffect(() => {
    // Only run once, skip if location already saved or already prompted this session
    if (ran.current) return;
    if (savedLocation) return;
    if (sessionStorage.getItem(PROMPTED_KEY)) return;
    if (!navigator.geolocation) return;

    ran.current = true;
    sessionStorage.setItem(PROMPTED_KEY, '1');

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        try {
          const { data } = await supabase.functions.invoke('places-autocomplete', {
            body: { type: 'reverse', lat: latitude, lng: longitude },
          });

          const cityName = data?.name;
          if (cityName) {
            saveLocation(cityName, latitude, longitude);
          } else {
            // Fallback: save coords with generic name
            saveLocation(`${latitude.toFixed(2)}, ${longitude.toFixed(2)}`, latitude, longitude);
          }
        } catch {
          // Reverse geocode failed, save raw coords
          saveLocation(`${latitude.toFixed(2)}, ${longitude.toFixed(2)}`, latitude, longitude);
        }
      },
      () => {
        // User denied or error — do nothing
      },
      { timeout: 10000, maximumAge: 300000 }
    );
  }, [savedLocation, saveLocation]);
}
